/* eslint-disable no-lone-blocks */
/**
 * @file CPCooperationCase
 * @author wanzhongyun
 */

import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { RootObject, TabsList,JumpArray } from '../../type';
import VideoListItem from './VideoListItem';
import './style.less';
const CPCooperationCase = (props: RootObject["CPCooperationCase"]) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const tabRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (tabRef.current && contentRef.current) {
      // console.log('tabRef.current:', tabRef.current);
      tabRef.current.style.left = `${178 * currentIndex}px`;
      contentRef.current.style.left = `-${1200 * currentIndex}px`;
    }
  }, [currentIndex]);
  return (
    <div className="co-creation-CPCooperation-case">
      <div className="co-creation-CPCooperation-case-title">
        {
          props.Title ?? ""
        }
      </div>
      {/* table */}
      <div className="co-creation-CPCooperation-case_content">
        {/* tablet头部 */}
        <div className="co-creation-CPCooperation-case-tab">
          {props.TabsList.map((item: TabsList, index: number) => (
            <div
              className={classNames('co-creation-CPCooperation-case-tab-item', {})}
              key={index}
              onClick={() => {
                setCurrentIndex(index);
              }}
            >
              <div
                className={classNames('co-creation-CPCooperation-case-tab-item-title', {
                  'current-tab-item': index === currentIndex
                })}
              >
                {item.title ?? ""}
              </div>
            </div>
          ))}
        </div>
        {/* 滚动条 */}
        <div className="co-creation-CPCooperation-case-vertical-scroll">
          <div className="current-selected-tab" ref={tabRef} />
        </div>
        {/* 内容 */}
        <div className="co-creation-CPCooperation-case-content-backimg">
          <div className="co-creation-CPCooperation-case-content-wrapper">
            <div className="co-creation-CPCooperation-case-content" ref={contentRef}>
              {/* 内容模块 */}

              {
                props.TabsList.map((value: TabsList, viewIndex: number) => {
                  return (
                    <div className="CPCooperation-case-content-module" key={viewIndex}>
                      {/* 右边视频内容 */}
                      <div className="CPCooperation-case-content-module-view">

                        <VideoListItem
                          backgroundVideo={value.content.videolLink}
                          link={value.content.videolLink}
                          backImg={value.content.sideImg}
                        />
                      </div>

                      {/* 左边文案信息 */}
                      <div className="CPCooperation-case-content-module-copy">
                        <div className="copy-title">
                          {
                            value.content.title ?? ""
                          }
                        </div>
                        <div className="copy-desc">
                          {
                            value.content.headerContent
                          }
                        </div>
                        <div className="copy-detail">
                          <span className="copy-detail-name">{value.content.jumpTitle}</span>
                          {
                            value.content.jumpArray.map((jumpValue:JumpArray,jumpIndex:number)=>{
                              return (
                                <a key={jumpIndex} className="copy-detail-link" href={jumpValue.detailLink} target='_blank' rel='noreferrer'>{jumpValue.title ?? ""}</a>
                              )
                            })
                          }
                        </div>
                      </div>
                    </div>
                  )
                })
              }



            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CPCooperationCase